<div class="contact-card">
  <h2 class="contact-card__title">Contato</h2>
  <div class="contact-card__informations">
    <div class="infos" >
      <p>Telefone: </p>
      <p class="infos-contact"> {{ contato.telefone }}</p>
    </div>
    <div class="infos" >
      <p>WhatsApp: </p>
      <p class="infos-contact"> {{ contato.whatsapp }}</p>
    </div>
    <div class="infos" >
      <p>Email: </p>
      <p class="infos-contact"> {{ contato.email }}</p>
    </div>
    <div class="infos-ad">
      <p class="infos-contact">Horário de funcionamento: {{ contato.horarioFuncionamento }}</p>
      <p><i>Endereço: {{ contato.endereco }}</i></p>
    </div>
  </div>
</div>


